var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "01) Icons/Filled/person-fill"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7C16 9.206 14.206 11 12 11C9.794 11 8 9.206 8 7C8 4.794 9.794 3 12 3C14.206 3 16 4.794 16 7ZM19 20C19 20.552 18.553 21 18 21H6C5.447 21 5 20.552 5 20C5 16.14 8.141 13 12 13C15.859 13 19 16.14 19 20Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_735_12659",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 14,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7C16 9.206 14.206 11 12 11C9.794 11 8 9.206 8 7C8 4.794 9.794 3 12 3C14.206 3 16 4.794 16 7ZM19 20C19 20.552 18.553 21 18 21H6C5.447 21 5 20.552 5 20C5 16.14 8.141 13 12 13C15.859 13 19 16.14 19 20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_735_12659)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFill);
export default __webpack_public_path__ + "static/media/person-fill.c5523ddb434daf16ad6236808f5839d9.svg";
export { ForwardRef as ReactComponent };